import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  onLabel?: string;
  offLabel?: string;
  size?: 'mini' | 'small' | 'large';
}

export function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  onLabel = 'ON',
  offLabel = 'OFF',
  size = 'small',
}: ToggleSwitchProps) {
  return (
    <div
      className={['ats-switch', `switch-${size}`, disabled ? 'disabled' : ''].filter(Boolean).join(' ')}
      onClick={() => { if (!disabled) onChange(!checked); }}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || undefined}
    >
      <div className={`switch-animate ${checked ? 'switch-on' : 'switch-off'}`}>
        <span className="switch-left">{onLabel}</span>
        <span className="knob">&nbsp;</span>
        <span className="switch-right">{offLabel}</span>
      </div>
    </div>
  );
}
